//#region src/core/ui/time-slider/chapters/data.ts
const TimeSliderChapterDataAttrs = {
	/** Present when playback is within the chapter. */
	active: "data-active",
	/** Present when pointer interaction highlights the chapter. */
	highlighted: "data-highlighted"
};
//#endregion
export { TimeSliderChapterDataAttrs };

//# sourceMappingURL=data.js.map